module.exports = __webpack_public_path__ + "img/backR.8ee3cb51.jpg";